import { useEffect } from 'react';
import { AppShell } from './components/layout/AppShell';
import { useUIStore } from './stores/uiStore';
import { useAuthStore } from './stores/authStore';
import { Login } from './components/auth/Login';

export function App() {
  const { theme } = useUIStore();
  const { isAuthenticated } = useAuthStore();

  // Initialize theme on mount
  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  if (!isAuthenticated) {
    return <Login />;
  }

  return <AppShell />;
}
